<!-- Added automation IDs 19/10/2026 DW -->
<div
  autosize
  autoFocus
  [ngClass]="{
    'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top',
    'sidebarNav-horizontal': options.horizontal,
    'dashboard-landing-page': !showBreadcrumb,
    cardBorder: options.cardBorder,
    orange_theme: options.activeTheme === 'orange_theme',
    blue_theme: options.activeTheme === 'blue_theme',
    aqua_theme: options.activeTheme === 'aqua_theme',
    purple_theme: options.activeTheme === 'purple_theme',
    green_theme: options.activeTheme === 'green_theme',
    cyan_theme: options.activeTheme === 'cyan_theme'
  }"
  [dir]="options.dir!"
>
  <!-- ============================================================== -->
  <!-- VerticalHeader -->
  <!-- ============================================================== -->
  @if (!options.horizontal) {
  <app-header
    [showToggle]="!isOver"
    (toggleCollapsed)="toggleCollapsed()"
    (toggleMobileNav)="sidenav.toggle()"
  ></app-header>
  }
  <!-- Horizontal: logo and profile are in the horizontal sidebar; top bar removed -->
  <mat-sidenav-container class="mainWrapper">
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->
    @if (!options.horizontal) {
    <mat-sidenav
      #leftsidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
    >
      <app-sidebar> </app-sidebar>
      <ng-scrollbar
        class="position-relative mini-scroll"
        style="height: calc(100vh - 230px)"
      >
        <mat-nav-list class="sidebar-list">
          @for (item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
    }
    <!-- ============================================================== -->
    <!-- horizontal Sidebar -->
    <!-- ============================================================== -->
    @if (resView) {
    <mat-sidenav
      #leftsidenav
      [mode]="'over'"
      [opened]="options.sidenavOpened && !isTablet"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
    >
      <app-sidebar> </app-sidebar>
      <ng-scrollbar
        class="position-relative mini-scroll"
        style="height: calc(100vh - 230px)"
      >
        <mat-nav-list class="sidebar-list">
          @for (item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
    }
    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content
      class="contentWrapper"
      [class.dashboard-landing-active]="!showBreadcrumb"
    >
      @if (options.horizontal) {
      <div
        class="horizontal-sidebar-zoom-wrapper"
        [style.height.px]="horizontalSidebarBaseHeight / horizontalZoomScale"
      >
        <div
          class="horizontal-sidebar-zoom-inner"
          [style.width.%]="100 * horizontalZoomScale"
          [style.height.px]="horizontalSidebarBaseHeight"
          [style.transform]="'scale(' + (1 / horizontalZoomScale) + ')'"
        >
          <app-horizontal-sidebar></app-horizontal-sidebar>
        </div>
      </div>
      }
      <main
        class="pageWrapper"
        [ngClass]="{
          maxWidth: options.boxed,
          'dashboard-landing': !showBreadcrumb
        }"
      >
        @if (showBreadcrumb) {
          <app-breadcrumb></app-breadcrumb>
        }
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
        <div class="customizerBtn">
          <button id="shell-customizer-right-btn" mat-fab color="primary" (click)="customizerRight.toggle()">
            <mat-icon>settings</mat-icon>
          </button>
        </div>
      </main>
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Customizer -->
    <!-- ============================================================== -->
    <mat-sidenav
      #customizerRight
      mode="over"
      position="end"
      class="fixed-customizer"
    >
      <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
<style>
  .footer a {
    color: #ff7043;
    text-decoration: none;
    font-weight: bold;
  }
</style>

<footer class="footer" style="padding: 10px; background-color: #f8f9fa">
  <div
    class="container-fluid"
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    "
  >
    <nav style="flex: 1">
      <ul style="list-style: none; padding: 0; margin: 0">
        <li style="display: inline">
          <a [href]="env.companyWWWURL" target="_blank">
            {{ env.companyName }}
          </a>
        </li>
      </ul>
    </nav>
    <div class="copyright" style="flex: 1; text-align: right">
      <span style="font-weight: bold">{{ env.appVersion }}</span> - &copy;
      <span style="font-weight: bold">{{ test | date : 'yyyy' }}</span
      >, made
      <!--with <i class="material-icons">favorite</i>-->
      by
      <a href="https://www.softsplice.co.za" target="_blank">SOFTSPLICE</a> for
      a better web.
    </div>
  </div>
</footer>
